import { Container, Grid } from '@material-ui/core'
import { useEffect, useState, useRef } from 'react'
import { ButtonHLPure, TooltipHLPure } from '../../pures'
import LabelPure from '../../pures/label/label.pure'
import { Field, Form, FormElement } from '@progress/kendo-react-form'
import { Checkbox, NumericTextBox } from '@progress/kendo-react-inputs'
import { useTranslation } from 'react-i18next'
import { CHATBOT_CONFIG_FIELDS } from '../../../utils'
import './chatbot-configuration.css'

const ChatbotCustomizationView = (props) => {
  const {
    initialData,
    saveData,
    profileImage: propProfileImage,
    backgroundImage: propBackgroundImage,
    onProfileImageChange,
    onBackgroundImageChange,
    visibleFields
  } = props

  const { t } = useTranslation('chatbot', { keyPrefix: 'configuration' })
  const { t: tCommon } = useTranslation('common')
  const [tempColor, setTempColor] = useState(initialData.primaryColor)
  const profileInputRef = useRef(null)
  const backgroundInputRef = useRef(null)
  const [localProfileImage, setLocalProfileImage] = useState(propProfileImage || null)
  const [localBackgroundImage, setLocalBackgroundImage] = useState(propBackgroundImage || null)

  const [formKey, setFormKey] = useState(1)

  const resetForm = () => setFormKey(formKey + 1)

  const renderCheckboxWithTooltip = (fieldId, fieldName, label, tooltipDescription) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Field
        id={fieldId}
        name={fieldName}
        component={Checkbox}
        label={label}
      />
      <TooltipHLPure
        positionTooltip={'right'}
        descriptionTooltip={tooltipDescription}
        informationIcon
      />
    </div>
  )

  
  const triggerProfileInput = () => {
    profileInputRef.current?.click()
  }

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0]
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader()
      reader.onload = (event) => {
        setLocalProfileImage(event.target.result)
        if (onProfileImageChange) {
          onProfileImageChange(event.target.result)
        }
      }
      reader.readAsDataURL(file)
    }
  }

  const handleBackgroundImageChange = (e) => {
    const file = e.target.files[0]
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader()
      reader.onload = (event) => {
        setLocalBackgroundImage(event.target.result)
        if (onBackgroundImageChange) {
          onBackgroundImageChange(event.target.result)
        }
      }
      reader.readAsDataURL(file)
    }
  }

    const triggerBackgroundInput = () => {
      backgroundInputRef.current?.click()
    }
    useEffect(() => {
    resetForm()
    //setLocalProfileImage(propProfileImage)
    //setLocalBackgroundImage(propBackgroundImage)
  }, [initialData])
  return (
    <Container maxWidth={'md'}>
      <Form
        key={`chatbot-configuration-${formKey}`}
        initialValues={initialData}
        onSubmit={saveData}
        render={(formRenderProps) => {
          return (
            <FormElement>
              <Grid container spacing={3}>
                {/* Selector de imagen de perfil */}
                <Grid item xs={6} md={6}>
                   <LabelPure title={t('customization.assistantImage')} editorId='assistantImage' />
                  <div className='image-preview-container profile-preview'>
                    <div className='image-preview'>
                      {localProfileImage ? (
                        <img 
                          src={localProfileImage} 
                          alt="Profile Preview" 
                          className='circle-image' 
                          onError={() => setLocalProfileImage(null)}
                        />
                      ) : (
                        <div className='placeholder'>{t('customization.selectProfileImage')}</div>
                      )}
                    </div>
                    <button 
                      onClick={triggerProfileInput} 
                      className="camera-button"
                      aria-label={t('common.changeProfileImage')}
                    >
                     +
                    </button>
                    <input
                      type="file"
                      ref={profileInputRef}
                      onChange={handleProfileImageChange}
                      accept="image/*"
                      className="hidden-input"
                    />
                  </div>
                </Grid>

                {/* Selector de imagen de fondo */}
                <Grid item xs={6} md={6}>
                  <LabelPure title={t('customization.assistantBackgroundImage')} editorId='assistantBackgroundImage' />
                  <div className='image-preview-container background-preview'>
                    <div className='image-preview'>
                      {localBackgroundImage ? (
                        <img 
                          src={localBackgroundImage} 
                          alt="Background Preview" 
                          className='background-image' 
                          onError={() => setLocalBackgroundImage(null)}
                        />
                      ) : (
                        <div className='placeholder'>{t('customization.selectBackgroundImage')}</div>
                      )}
                    </div>
                    <button 
                      onClick={triggerBackgroundInput} 
                      className="camera-button background-button"
                      aria-label={t('common.changeBackgroundImage')}
                    >
                      +
                    </button>
                    <input
                      type="file"
                      ref={backgroundInputRef}
                      onChange={handleBackgroundImageChange}
                      accept="image/*"
                      className="hidden-input"
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <LabelPure title={t('customization.colorPicker')} editorId='colorPicker' />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <Field
                      name='primaryColor'
                      component={({ onChange }) => {
                        return (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <input
                              type='color'
                              defaultValue={tempColor}
                              onBlur={(e) => {
                                onChange({ target: { value: e.target.value } })
                                setTempColor(e.target.value)
                                console.log(e.target.value)
                              }}
                              style={{
                                width: '36px',
                                height: '36px',
                                padding: 0,
                                border: '1px solid #ccc',
                                borderRadius: '4px'
                              }}
                            />
                          </div>
                        );
                      }}
                    />
                  </div>
                </Grid>
                {
                  visibleFields.has(CHATBOT_CONFIG_FIELDS.CLIENT_SUPPORT) && (
                    <Grid item xs={12}>
                      {renderCheckboxWithTooltip(
                        'clientSupport',
                        'clientSupport',
                        t('customization.clientSupport'),
                        t('customization.tooltipClientSupport')
                      )}
                    </Grid>
                  )
                }
                {
                  initialData.useWhatsapp && visibleFields.has(CHATBOT_CONFIG_FIELDS.SEND_AUDIO) && (
                  <Grid item xs={12}>
                    {renderCheckboxWithTooltip(
                      'sendAudio',
                      'sendAudio',
                      t('customization.sendAudio'),
                      t('customization.tooltipSendAudio')
                    )}
                  </Grid>
                  )
                }
                {
                  visibleFields.has(CHATBOT_CONFIG_FIELDS.SEND_ATTACHMENT) && (
                    <Grid item xs={12}>
                      {renderCheckboxWithTooltip(
                        'sendAttachment',
                        'sendAttachment',
                        t('customization.sendAttachment'),
                        t('customization.tooltipSendAttachment')
                      )}
                    </Grid>
                  )
                }
                {visibleFields.has(CHATBOT_CONFIG_FIELDS.SEND_ATTACHMENT) && formRenderProps.valueGetter('sendAttachment') && (
                  <>
                    <Grid item xs={12} md={6}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <LabelPure title={t('customization.attachmentFields.fileSize')} editorId='fileSize' />
                        <TooltipHLPure
                          positionTooltip={'right'}
                          descriptionTooltip={t('customization.attachmentFields.tooltipFileSize')}
                          informationIcon
                        />
                      </div>
                      <Field
                        name={'fileSize'}
                        component={NumericTextBox}
                        format="n0"
                        min={1}
                        max={30}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LabelPure title={t('customization.attachmentFields.sendFileMax')} editorId='sendFileMax' />
                      <Field
                        name={'sendFileMax'}
                        component={NumericTextBox}
                        format="n0"
                        min={1}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        id='activeExpirationDays'
                        name={'activeExpirationDays'}
                        component={Checkbox}
                        label={t('customization.activeExpirationDays')}
                      />
                    </Grid>
                    {
                      formRenderProps.valueGetter('activeExpirationDays') &&
                      <Grid item xs={12} md={6}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <LabelPure title={t('customization.attachmentFields.fileExpirationDays')} editorId='fileExpirationDays' />
                          <TooltipHLPure
                            positionTooltip={'right'}
                            descriptionTooltip={t('customization.attachmentFields.tooltipFileExpirationDays')}
                            informationIcon
                          />
                        </div>
                        <Field
                          name={'fileExpirationDays'}
                          component={NumericTextBox}
                          format="n0"
                          min={1}
                        />
                      </Grid>
                    }
                  </>
                )}

                <Grid item xs={12} className='button-actions'>
                  {
                    formRenderProps.modified &&
                    <ButtonHLPure colorScheme='error' outlined nameBtn={tCommon('cancel')} onClick={() => {
                      resetForm()
                      setTempColor(initialData.primaryColor)
                    }} />
                  }
                  <ButtonHLPure primary nameBtn={tCommon('save')} type='submit' />
                </Grid>
              </Grid>
            </FormElement>
          )
        }}
      />
    </Container>
  )
}

export default ChatbotCustomizationView